import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminContenuti() {
  const [content, setContent] = useState({});
  const [active, setActive] = useState("hero");
  const [raw, setRaw] = useState("");

  const load = () => api.get("/content").then((r) => {
    setContent(r.data);
    setRaw(JSON.stringify(r.data[active] || {}, null, 2));
  });
  useEffect(() => { load(); }, []);

  useEffect(() => {
    setRaw(JSON.stringify(content[active] || {}, null, 2));
  }, [active, content]);

  const save = async () => {
    try {
      const value = JSON.parse(raw);
      await api.put(`/admin/content/${active}`, { key: active, value });
      toast.success("Contenuto salvato");
      load();
    } catch (e) {
      toast.error("JSON non valido");
    }
  };

  const keys = Object.keys(content);

  return (
    <div data-testid="admin-contenuti" className="p-10">
      <h1 className="font-serif text-4xl text-white mb-2">Contenuti del sito</h1>
      <p className="text-white/50 text-sm mb-8">Modifica i testi delle sezioni: hero, chi siamo, servizi, contatti.</p>

      <div className="flex gap-2 mb-6 flex-wrap">
        {keys.map((k) => (
          <button key={k} onClick={() => setActive(k)} data-testid={`content-tab-${k}`}
            className={`px-4 py-2 text-xs uppercase tracking-widest border ${active === k ? "border-[var(--gold)] text-[var(--gold)]" : "border-white/15 text-white/60"}`}>
            {k}
          </button>
        ))}
      </div>

      <div className="luxe-card p-5">
        <textarea
          data-testid="content-editor"
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          rows={22}
          className="w-full bg-[#060f1f] border border-white/10 p-4 text-white text-sm font-mono focus:border-[var(--gold)] outline-none"
        />
        <button onClick={save} data-testid="content-save" className="btn-gold mt-4">Salva Contenuto</button>
      </div>
    </div>
  );
}
